export default {
    DRAFT: 100,
    PENDING: 200,
    APPROVED: 300,
    REJECTED: 400,
    LIVE: 500,
    EXPIRED: 600,
    CANCELED: 700
}